/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	ErrorMessage,
	ErrorMessageFromJSON,
	ErrorMessageFromJSONTyped,
	ErrorMessageToJSON,
} from "./ErrorMessage";
import {
	SwitchProfileResponseDTO,
	SwitchProfileResponseDTOFromJSON,
	SwitchProfileResponseDTOFromJSONTyped,
	SwitchProfileResponseDTOToJSON,
} from "./SwitchProfileResponseDTO";

/**
 *
 * @export
 * @interface SwitchProfileResponseDTORequestResponse
 */
export interface SwitchProfileResponseDTORequestResponse {
	/**
	 *
	 * @type {SwitchProfileResponseDTO}
	 * @memberof SwitchProfileResponseDTORequestResponse
	 */
	response?: SwitchProfileResponseDTO;
	/**
	 *
	 * @type {ErrorMessage}
	 * @memberof SwitchProfileResponseDTORequestResponse
	 */
	errorMessage?: ErrorMessage;
}

export function SwitchProfileResponseDTORequestResponseFromJSON(
	json: any
): SwitchProfileResponseDTORequestResponse {
	return SwitchProfileResponseDTORequestResponseFromJSONTyped(json, false);
}

export function SwitchProfileResponseDTORequestResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): SwitchProfileResponseDTORequestResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		response: !exists(json, "response")
			? undefined
			: SwitchProfileResponseDTOFromJSON(json["response"]),
		errorMessage: !exists(json, "errorMessage")
			? undefined
			: ErrorMessageFromJSON(json["errorMessage"]),
	};
}

export function SwitchProfileResponseDTORequestResponseToJSON(
	value?: SwitchProfileResponseDTORequestResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		response: SwitchProfileResponseDTOToJSON(value.response),
		errorMessage: ErrorMessageToJSON(value.errorMessage),
	};
}
